const QUICK_BAG_ACTIONS = {
  FORCE_UPDATE: 'quickbag:forceUpdate',
  GET_DATA: 'quickbag:getData',
  OPEN: 'quickbag:open',
  CLOSE: 'quickbag:close',
  INIT: 'quickbag:initialize',
  DESTROY: 'quickbag:destroy',
  UPDATE_COUNT: 'quickbag:updateCount',
  TEAR_DOWN: 'quickbag:tearDown',
};

export default QUICK_BAG_ACTIONS;
